import {useQuery} from '@apollo/react-hooks';

import type {
    GetInboxDashboardChecklist,
    GetInboxDashboardChecklist_inboxDashboardChecklist as InboxDashboardChecklist,
} from 'nutshell-graphql-types';

import GET_INBOX_DASHBOARD_CHECKLIST from '../queries/get-inbox-dashboard-checklist.graphql';

export const useGetInboxDashboardChecklist = (): {
    inboxDashboardChecklist: InboxDashboardChecklist | null | undefined;
    completedCount: number | null | undefined;
    totalCount: number | null | undefined;
    checklistIsComplete: boolean;
    isLoading: boolean;
} => {
    const {data, loading: isLoading} = useQuery<GetInboxDashboardChecklist, Record<any, any>>(
        GET_INBOX_DASHBOARD_CHECKLIST,
        {
            fetchPolicy: 'cache-and-network',
        }
    );

    const inboxDashboardChecklist = data ? data.inboxDashboardChecklist : null;

    const completedCount = inboxDashboardChecklist
        ? inboxDashboardChecklist.items.filter((item) => item.isComplete).length
        : undefined;
    const totalCount = inboxDashboardChecklist ? inboxDashboardChecklist.items.length : undefined;
    const checklistIsComplete = Boolean(totalCount && completedCount === totalCount);

    return {
        inboxDashboardChecklist,
        completedCount,
        totalCount,
        checklistIsComplete,
        isLoading,
    };
};
